import axios from "@/libs/api.request";

export const getPodError = params => {
  return axios.request({
    url: "/tracker/pod/exceptions",
    method: "get",
    params
  });
};
export const confirmError = data => {
  return axios.request({
    url: `/tracker/pod/exception`,
    method: "post",
    data
  });
};
